export const userData = [
    {
        name: 'Jan',
        'Active User': 4000,
    },
    {
        name: 'Feb',
        'Active User': 3000,
    },
    {
        name: 'Mar',
        'Active User': 4000,
    },
    {
        name: 'Apr',
        'Active User': 5000,
    },
    {
        name: 'May',
        'Active User': 4000,
    },
    {
        name: 'Jun',
        'Active User': 2000,
    },
    {
        name: 'Jul',
        'Active User': 4000,
    },
    {
        name: 'Agu',
        'Active User': 3000,
    },
    {
        name: 'Sep',
        'Active User': 4000,
    },
    {
        name: 'Oct',
        'Active User': 1000,
    },
    {
        name: 'Nov',
        'Active User': 4000,
    },
    {
        name: 'Dec',
        'Active User': 3000,
    },
];

export const productData = [
    {
        name: 'Jan',
        'Sales': 4000,
    },
    {
        name: 'Feb',
        'Sales': 3000,
    },
    {
        name: 'Mar',
        'Sales': 4000,
    },
]

export const userRows = [
    {
        id: 1,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 2,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 3,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 4,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 5,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 6,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 7,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 8,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 9,
        username: 'jon Snow',
        avatar: 'https://picsum.photos/200',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
    {
        id: 10,
        username: 'jon Snow',
        img: 'https://picsum.photos/202',
        email: 'jon@gamil.com',
        status: 'active',
        transction: '$120.00'
    },
];
export const productRows = [
    {
        id: 1,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 2,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 3,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 4,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 5,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 6,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 7,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 8,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 9,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
    {
        id: 10,
        name: 'Apple Airbods',
        img: 'https://picsum.photos/202',
        stock: 123,
        status: 'active',
        price: '$120.00'
    },
];